import { Tabs, Tab, Divider, Box } from "@mui/material"
import { FC, ReactElement, useMemo } from "react"
import React from "react"
import { Link, matchPath, Redirect, RouteProps, useLocation } from "react-router-dom"
import { Content } from "@/components/content/Content"
import { Helmet } from 'react-helmet-async'
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource"
import { useHasFeature } from "@/utils/useHasFeature"
import { allowReleaseRoute } from "@/authProvider/permissionMap"
import { useOdPermissions } from "@/authProvider/useOdPermissions"


const ProductsRelease: FC<WrappedComponentProps> = ({
  children,
  tabs,
  options,
}) => {
  const permissions = useOdPermissions()
  const location = useLocation()
  const { rest: activeItem } = 
    matchPath<{rest:string}>(location.pathname, { path: '/release/:rest'})?.params || {}

  const hasFeature = useHasFeature()
  
  const allowedTabs = useMemo(() => 
    tabs.filter(tab => 
      allowReleaseRoute(tab.primaryPath || tab.path, hasFeature.OnDataDriver, hasFeature.OnDataSecureFile, hasFeature.OnDataSecureDB, permissions)), 
  [tabs, permissions, hasFeature.OnDataDriver, hasFeature.OnDataSecureFile, hasFeature.OnDataSecureDB])
  const switcherElem = children as ReactElement
  const [resElems, ...rest] = switcherElem.props.children as any[]
  const resElems2 = resElems.map((child:any) => {
    const res = child as ReactElement<RouteProps>
    // const x = ((res.props.path !== '/release/jdbc' 
    //   && res.props.path !== '/release/odbc' 
    //   && res.props.path !== '/release/sqlclient') 
    //   || hasFeature.OnDataDriver)
    //   ? (res.props.path !== '/release/securefile' || hasFeature.OnDataSecureFile) ? res : null : null
    if((res.props.path === '/release/jdbc' 
      || res.props.path === '/release/odbc' 
      || res.props.path === '/release/sqlclient') && hasFeature.OnDataDriver) {
      return res
    }
    if(res.props.path === '/release/encryptiontool' && hasFeature.OnDataSecureDB) {
      return res
    }
    if(res.props.path === '/release/securefile' && hasFeature.OnDataSecureFile){
      return res
    }
    return null
  })
  
  if (!hasFeature.requested && !allowReleaseRoute(location.pathname, hasFeature.OnDataDriver, hasFeature.OnDataSecureFile, hasFeature.OnDataSecureDB, permissions)) {
    // postpone the route decision, until the feature info is available
    return null
  }
  if (permissions && location.pathname.length > '/release/'.length) {
    if (!allowReleaseRoute(location.pathname, hasFeature.OnDataDriver, hasFeature.OnDataSecureFile, hasFeature.OnDataSecureDB, permissions)) {
      if(hasFeature.OnDataSecureDB){
        return <Redirect to="/release/encryptiontool" />
      } else {
        if(hasFeature.OnDataSecureFile){
          return <Redirect to="/release/securefile" />
        } else {
          return <Redirect to="/" />
        }
      }
    }
  }
  return (
    <Content pageName="Product Releases" resourceName="Product Releases" breadcrumbs={options?.breadcrumbs} >
      <Helmet>
        <title>Product Releases | OnData</title>
      </Helmet>
      <Tabs
        indicatorColor="primary"
        scrollButtons="auto"
        textColor="primary"
        variant="scrollable"
        value={`/release/${activeItem}`}
      >
        {allowedTabs.map((tab) => (
          <Tab
            component={Link}
            key={tab.path}
            label={tab.label}
            value={tab.path}
            to={tab.primaryPath || tab.path}
          />
        ))}
      </Tabs>
      <Divider />
      <Box sx={{ mt: 3 }}>
        {React.cloneElement(switcherElem, { ...switcherElem.props, children: [resElems2, ...rest] })}
      </Box>
    </Content>
  )
}


export const ProductsReleaseComposite = withCompositeResource(ProductsRelease)

